var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-dialog',{attrs:{"width":750,"identifier":"upgrade-changelog-dialog"},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var title = ref.title;
return [_c('i18n',{staticClass:"heading",attrs:{"path":title,"tag":"h2"}})]}},{key:"default",fn:function(ref){
var params = ref.params;
return _vm._l((params.entries),function(entry){return _c('div',{key:entry.id},[_c('h3',[_vm._v(_vm._s(entry.readableName))]),_vm._v(" "),_vm._l((entry.docs.changelog),function(changelog,index){return _c('nl2br',{key:index,attrs:{"text":changelog,"tag":"p"}})})],2)})}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cc2d660","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/UpgradeChangelogDialog.vue
// module id = null
// module chunks = 